'use client';

import React from 'react';

import { Box, Flex, Stack } from '@chakra-ui/react';
import { Form, Formik } from 'formik';
import Link from 'next/link';

import { LoadingButton } from '@components/custom-buttons';
import { FormControlTextField } from '@components/custom-form-control';
import { CustomText } from '@components/Custom-text';
import { UserType } from '@enums/index';
import { paths } from '@routes/path';

import { LoginSchema } from '../../schema';
import { LoginRequest } from '../../types';

interface LoginFormProps {
    onSubmit: (values: LoginRequest) => void | Promise<any>;
    isLoading?: boolean;
    userType: UserType;
}

const initialValues = {
    email: '',
    password: '',
};

const LoginForm = ({ onSubmit, isLoading, userType }: LoginFormProps) => {
    const [showPassword, setShowPassword] = React.useState(false);

    const handleSubmit = async (values: LoginRequest) => {
        onSubmit(values);
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={LoginSchema}
            onSubmit={handleSubmit}
        >
            {({ isSubmitting }) => (
                <Form>
                    <Stack width="100%" spacing={4}>
                        <FormControlTextField
                            name="email"
                            placeholder="Enter your email"
                            label="Email"
                            type="email"
                            isRequired
                        />
                        <FormControlTextField
                            name="password"
                            placeholder="Enter your password"
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            isRequired
                            showRightElement
                            onRightElementClick={() => setShowPassword(prev => !prev)}
                        />

                        <Flex width="100%" justifyContent="flex-end">
                            <Link
                                href={
                                    userType === UserType.Mentee
                                        ? paths.mentee.auth.forgotPassword
                                        : paths.mentor.auth.forgotPassword
                                }
                            >
                                <CustomText color="primary.light">Forgot password?</CustomText>
                            </Link>
                        </Flex>
                    </Stack>
                    <Box mt={8} width="100%">
                        <LoadingButton
                            buttonLabel={`Sign-In as ${
                                userType === UserType.Mentor ? 'Mentor' : 'Mentee'
                            }`}
                            type="submit"
                            isLoading={isSubmitting || isLoading!}
                            loadingText="Logging in"
                        />
                    </Box>
                </Form>
            )}
        </Formik>
    );
};

export default LoginForm;
